// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import api from './api'
import configs from './commons/Config'
import tips from './commons/Tips'
import userStore from './commons/UserStore'
import waterMark from './commons/WaterMark'


Vue.config.productionTip = false

Vue.prototype.$http = api.$http;
Vue.prototype.$http2 = api.$http2;
Vue.prototype.$config = configs;
Vue.prototype.$tips = tips;
Vue.prototype.$userStore = userStore;
Vue.prototype.$waterMark = userStore;


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js